import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, Fragment as _Fragment, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode } from "vue"

const _hoisted_1 = { class: "row items-center q-mb-md q-gutter-sm" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_q_btn_toggle = _resolveComponent("q-btn-toggle")!
  const _component_q_space = _resolveComponent("q-space")!
  const _component_SearchInput = _resolveComponent("SearchInput")!
  const _component_q_btn = _resolveComponent("q-btn")!
  const _component_PersonsView = _resolveComponent("PersonsView")!
  const _component_TrashedPersonsView = _resolveComponent("TrashedPersonsView")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", _hoisted_1, [
      (_ctx.hasTrashed)
        ? (_openBlock(), _createBlock(_component_q_btn_toggle, {
            key: 0,
            modelValue: _ctx.viewMode,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.viewMode) = $event)),
            "toggle-color": "primary",
            options: _ctx.toggleOptions
          }, null, 8, ["modelValue", "options"]))
        : _createCommentVNode("", true),
      _createVNode(_component_q_space),
      (_ctx.viewMode === 'persons')
        ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
            _createVNode(_component_SearchInput, {
              "model-value": _ctx.personKeyword,
              placeholder: "Search people...",
              style: {"width":"200px"},
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.personKeyword = $event))
            }, null, 8, ["model-value"]),
            _createVNode(_component_q_btn, {
              color: _ctx.mergeMode ? 'negative' : 'grey',
              icon: _ctx.mergeMode ? 'fa fa-times' : 'fa fa-compress-arrows-alt',
              label: _ctx.mergeMode ? 'Cancel' : 'Merge',
              flat: "",
              onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.mergeMode = !_ctx.mergeMode))
            }, null, 8, ["color", "icon", "label"])
          ], 64))
        : _createCommentVNode("", true)
    ]),
    (_ctx.viewMode === 'persons')
      ? (_openBlock(), _createBlock(_component_PersonsView, {
          key: 0,
          "client-id": _ctx.client.id,
          keyword: _ctx.personKeyword,
          "merge-mode": _ctx.mergeMode,
          onMergeComplete: _cache[3] || (_cache[3] = ($event: any) => (_ctx.mergeMode = false))
        }, null, 8, ["client-id", "keyword", "merge-mode"]))
      : _createCommentVNode("", true),
    (_ctx.viewMode === 'trash')
      ? (_openBlock(), _createBlock(_component_TrashedPersonsView, {
          key: 1,
          "client-id": _ctx.client.id
        }, null, 8, ["client-id"]))
      : _createCommentVNode("", true)
  ]))
}